import React from 'react';
import AribaContent from '../components/AribaContent/AribaContent';
import CtaSection from '../components/CtaSection/CtaSection';

const SapAribaPage = () => {
  return (
    <>
      <AribaContent />
      <CtaSection />
    </>
  );
};

export default SapAribaPage;
